module.exports = __webpack_public_path__ + "static/media/chatLoader.4dab1791.gif";